<template>
  <hr class="mt-6 mb-4 w-full border-t border-gray-700" />
</template>

<script setup></script>
